/** @jsxImportSource @emotion/react */
"use client";

import {
  matchSelectableGuide,
  useCurrentQueueItem,
  usePlayer,
} from "@packages/media";
import type { Track } from "@packages/sdk";
import { useCallback } from "react";

import { SelectLengthList } from "./SelectLengthList.emotion";

export const SelectLengthContent = () => {
  const { currentItem } = useCurrentQueueItem();
  const player = usePlayer();
  if (currentItem?.type === "radio_song") return null;

  const currentGuide = currentItem?.prayer?.selectable_guides?.find((g) =>
    matchSelectableGuide(g.guide_ids, currentItem.selected_audio.guide_ids),
  );

  const lengths = currentGuide.tracks;

  const handleSetSelectedLength = useCallback(
    (
      option:
        | Partial<Track>
        | ((prev: Partial<Track> | null) => Partial<Track>),
    ) => {
      const newOption = typeof option === "function" ? option(null) : option;
      player.switchTo(newOption);
    },
    [player],
  );

  return (
    <SelectLengthList
      selectedLength={currentItem?.selected_audio}
      setSelectedLength={handleSetSelectedLength}
      options={lengths}
    />
  );
};
